import React from 'react';
import { Button } from './ui/Button';
import { Star, ShieldCheck, Clock } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-gradient-to-b from-amber-50 via-white to-slate-50 pt-12 pb-20 overflow-hidden" data-id="element-36">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20" data-id="element-37">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-amber-200 blur-3xl" data-id="element-38"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 rounded-full bg-blue-900/20 blur-3xl" data-id="element-39"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-40">
        <div className="max-w-4xl mx-auto" data-id="element-41">
          {/* Badge */}
          <div className="text-center mb-6" data-id="element-42">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-900 text-amber-400 rounded-full text-sm font-semibold mb-4" data-id="element-43">
              <Star className="h-4 w-4 fill-amber-400" data-id="element-44" />
              <span data-id="element-45">Sistema completo para docentes argentinos</span>
            </div>
          </div>

          {/* Title - Compact and condensed like reference */}
          <div className="text-center mb-10" data-id="element-46">
            <h1 className="text-[28px] leading-[1.15] sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 mb-0 tracking-tight" data-id="element-47">
              ORGANIZA TODO TU AÑO
              <br data-id="element-48" />
              DE <span className="text-blue-900" data-id="element-49">DERECHO SIN ESTRÉS</span>
            </h1>
          </div>

          {/* Image */}
          <div className="mb-8" data-id="element-50">
            <div className="relative z-10 transform transition-transform hover:scale-105 duration-500 cursor-pointer max-w-2xl mx-auto" onClick={scrollToPricing} data-id="element-51">
              <img src="https://cdn.magicpatterns.com/uploads/tMZG5rVVPzna4TQY49K55p/mockup_principal_derecho_360.png" alt="Derecho 360 Pack Completo" className="w-full drop-shadow-2xl" data-id="element-52" />
            </div>
            {/* Glow effect behind image */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1/2 h-1/2 bg-amber-500/20 blur-[80px] rounded-full -z-10" data-id="element-53"></div>
          </div>

          {/* Product Title and Description */}
          <div className="text-center mb-10" data-id="element-54">
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-id="element-55">
              DERECHO 360
            </h2>
            <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-56">
              Sistema completo de proyectos, experiencias y evaluaciones listas
              para usar. Todo tu año de Derecho resuelto en un clic.
            </p>
          </div>

          {/* CTA Button */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10" data-id="element-57">
            <Button onClick={scrollToPricing} size="xl" withIcon data-id="element-58">
              QUIERO ACCESO INMEDIATO
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-500 font-medium" data-id="element-59">
            <div className="flex items-center gap-2" data-id="element-60">
              <ShieldCheck className="h-5 w-5 text-green-600" data-id="element-61" />
              <span data-id="element-62">Compra 100% Segura</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-63">
              <Clock className="h-5 w-5 text-blue-900" data-id="element-64" />
              <span data-id="element-65">Acceso de por vida</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}